// extracted by mini-css-extract-plugin
module.exports = {"container":"ToggleButton_container__YS3xp","switch":"ToggleButton_switch__kGJpB","slider":"ToggleButton_slider__S5GEj"};